<template>
  <div class="paymentPage"
       v-loading="loading">
    <div class="pop">
      <el-dialog title="账单详情"
                 :visible.sync="dialogVisible"
                 width="500px">
        <div class="bill_list">
          <div class="bill_item">
            <span class="bill_title">账单号：</span>
            <span class="bill_centent">{{particularsData.payid}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">订单物流号：</span>
            <span class="bill_centent">{{particularsData.wlnum}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">订单ID：</span>
            <span class="bill_centent">{{particularsData.orderid}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">账单类型：</span>
            <span class="bill_centent">{{particularsData.fdtypename}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">账单时间：</span>
            <span class="bill_centent">{{common.formatDate(particularsData.createtime)}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">更新时间：</span>
            <span class="bill_centent">{{particularsData.endtime==0?'未更新':common.formatDate(particularsData.endtime)}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">收件人：</span>
            <span class="bill_centent">{{particularsData.sjname}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">收件地址：</span>
            <span class="bill_centent">{{particularsData.sjgj+' '+particularsData.sjprovince+' '+particularsData.sjcity+' '+particularsData.sjaddress}}</span>
          </div>

          <div class="bill_item"
               style="width:100%">
            <span class="bill_title">账单备注：</span>
            <span class="bill_centent">{{particularsData.info}}</span>
          </div>

          <div class="bill_item"
               style="width:100%">
            <span class="bill_title">账单金额：</span>
            <span class="bill_centent"
                  style="font-weight: 700; color: #d00016;">{{particularsData.allprice}} CNY</span>
          </div>
        </div>

        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="扫码支付"
                 :visible.sync="isWechatQr"
                 v-if="isWechatQr"
                 width="500px"
                 @close='closeDialog'
                 :before-close="handleClose"
                 class="scanQr_view">
        <el-image style="width: 400px;height:400px"
                  :src="wechatQr"
                  fit="fit"></el-image>
      </el-dialog>
      <el-dialog title="联系财务"
                 :visible.sync="isShowRelationService"
                 v-if="isShowRelationService"
                 width="500px"
                 :before-close="handleClose">
        <div class="service_view">
          <el-image style="width: 400px;height:400px"
                    :src="gathering.skinfo.skinfo.wechat.qr_url"
                    fit="fit"></el-image>
          <div style=" margin-top: 20px;">
            微信号：{{gathering.skinfo.skinfo.wechat.code}}
          </div>
        </div>
      </el-dialog>

    </div>
    <div class="absolute_bottom"
         style="justify-content:space-between ;"
         v-if="activeName==1">
      <div style="margin-left:10px">
        <el-link @click="getConfiguration()"
                 target="_blank">联系财务</el-link>
      </div>
      <div style='display:flex'>
        <div class="bottom_price">
          <div class="price_title">实付金额：</div>
          <div class="price"
               size="medium">￥{{gathering.payparams?gathering.payparams.fee:''}}</div>
        </div>
        <div class="bottom_btn">
          <el-button type="success"
                     @click="confirmWechat">微信付款</el-button>

        </div>
      </div>

    </div>

    <div class="absolute_bottom"
         style="justify-content:space-between ;"
         v-if="activeName==3">
      <div style="margin-left:10px">
        <el-link @click="getConfiguration()"
                 target="_blank">联系财务</el-link>
      </div>
      <div style='display:flex'>
        <div class="bottom_price">
          <div class="price_title">实付金额：</div>
          <div class="price"
               size="medium">￥{{gathering.payparams?gathering.payparams.fee:''}}</div>
        </div>
        <div class="bottom_btn">
          <el-button type="success"
                     @click="walletPay">钱包付款</el-button>

        </div>
      </div>

    </div>
    <div class="absolute_bottom"
         v-if="activeName==2">
      <div class="bottom_btn">
        <el-button type="success"
                   @click="getConfiguration">联系财务</el-button>
      </div>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="对公微信"
                   v-if="patternPayment.wechat?patternPayment.wechat.switch:false"
                   name="1"></el-tab-pane>
      <el-tab-pane label="对公银行"
                   v-if="gathering.skinfo.skinfo.bank.open"
                   name="2"></el-tab-pane>
      <el-tab-pane label="钱包支付"
                   v-if="patternPayment.credit?patternPayment.credit.switch:false"
                   name="3"></el-tab-pane>
    </el-tabs>
    <el-tag type='warning'>
      <span>{{activeName==1?'确认支付信息后点击底部微信付款进行支付，如有疑问或其他需求请点击底部联系财务。':activeName==2?'确认支付信息后请转账到下方任一账户，保留支付凭证后点击底部联系财务。':'钱包支付请先确定钱包额度足够，如有疑问或其他需求请点击底部联系财务。'}}</span>
    </el-tag>
    <div v-if="is_order==1"
         class="orderInfo">
      <el-table :data="monthlyVisibleData"
                style="width: 100%"
                height="100%">
        <el-table-column label="账单时间"
                         width="200">
          <template slot-scope="scope">
            <span>{{common.formatDate(scope.row.createtime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payid"
                         label="账单号"
                         width="180">
        </el-table-column>
        <el-table-column label="物流单号"
                         width="170">
          <template slot-scope="scope">
            <span>{{scope.row.wlnum}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="sjname"
                         label="收件姓名/代码"
                         width="120">
        </el-table-column>
        <el-table-column label="账单金额（ CNY ）"
                         width="150">
          <template slot-scope="scope">
            <span class="parice_show"> {{scope.row.allprice}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address"
                         align="right">
          <template slot-scope="scope">
            <div class="operationClass">
              <el-button size="mini"
                         @click="showParticulars(scope.row)">
                查看详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="orderInfo"
         v-if="is_order==2||is_order==3">
      <el-descriptions title="收寄人详情"
                       direction="vertical"
                       :column="8"
                       border>
        <el-descriptions-item label="寄件人"
                              :span="1">{{order_data.jjname}}</el-descriptions-item>
        <el-descriptions-item label="手机号"
                              :span="2">{{order_data.jjmobile}}</el-descriptions-item>
        <el-descriptions-item label="寄件地址"
                              :span="3">{{(order_data.jjprovince||'')+(order_data.jjcity||'')+(order_data.jjaddress||'')}}</el-descriptions-item>
        <el-descriptions-item label="收件国家"
                              :span="1">
          {{order_data.gjname}}
        </el-descriptions-item>

        <el-descriptions-item label="寄件邮政编码"
                              :span="1">{{order_data.jjzipcode||'未填写'}}</el-descriptions-item>

        <el-descriptions-item label="收件人/仓库"
                              :span="1">{{order_data.sjname}}</el-descriptions-item>
        <el-descriptions-item label="收件人联系方式"
                              :span="2">{{order_data.sjmobile||'未填写'}}</el-descriptions-item>
        <el-descriptions-item label="收件地址"
                              :span="3">{{(order_data.gjname||'')+(order_data.sjprovince||'')+(order_data.sjcity||'')+(order_data.sjaddress||'')}}</el-descriptions-item>
        <el-descriptions-item label="收件公司/FBA"
                              :span="1">
          {{order_data.sjcompanyname}}
        </el-descriptions-item>
        <el-descriptions-item label="收件邮政编码"
                              :span="1">{{order_data.sjzipcode||'未填写'}}</el-descriptions-item>

      </el-descriptions>

      <el-descriptions title="账单信息"
                       v-if="is_order==2"
                       style='margin-top:15px'
                       direction="vertical"
                       :column="8"
                       border>
        <el-descriptions-item label="账单类型"
                              :span="1">{{payparams.title}}</el-descriptions-item>
        <el-descriptions-item label="账单ID"
                              :span="2">{{payparams.ordersn}}</el-descriptions-item>
        <el-descriptions-item label="支付单号"
                              :span="3">{{payparams.tid}}</el-descriptions-item>
        <el-descriptions-item label="报价ID"
                              :span="1">
          {{order_data.bjid}}
        </el-descriptions-item>

        <el-descriptions-item label="账单金额"
                              :span="1">{{payparams.fee}} 元</el-descriptions-item>
      </el-descriptions>

      <el-table :data="getBill_list[0].fdlist"
                style="width: 100%">
        <el-table-column prop="address"
                         label="创建时间">
          <template slot-scope="scope">
            {{common.formatDate(scope.row.createtime)}}
          </template>
        </el-table-column>
        <el-table-column prop="payid"
                         label="账单号">
        </el-table-column>
        <el-table-column prop="info"
                         label="名称">
        </el-table-column>
        <el-table-column prop="allprice"
                         label="金额">
        </el-table-column>
        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            {{scope.row.status == 0?'未付款': scope.row.status == 1?'待审核':scope.row.status==2?'已付款':scope.row.status==3?'部分付款':'其他'}}
          </template>
        </el-table-column>

      </el-table>

    </div>

    <div class="otherPay"
         v-if="activeName==2">
      <div class="otherPay_view">
        <div class="tabs_view">
          <div class="bank_view_item tabs_view_item">
            <div class="bank_item"
                 v-for="(item,index) in gathering.skinfo.skinfo.bank.open"
                 :key="index">
              <div class="item_content">
                <div class="content_title">持卡人：</div>{{item.name}}
              </div>
              <div class="item_content">
                <div class="content_title">银行名称：</div> {{item.bankName}}
              </div>
              <div class="item_content">
                <div class="content_title">支行名称：</div> {{item.subBranch}}
              </div>
              <div class="item_content">
                <div class="content_title">卡号：</div> {{item.code}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wallet"
         v-if="activeName==3">
      <div>钱包余额：</div>
      <div>{{walletInfo}} 元</div>
    </div>

  </div>
</template>

<script>
import { apiPayment, apiBill, apiSystemInfo, apiOrderDetails, apiGetPlay, apiUserData, apiPlay, apiBillInfo } from '@/request/api'
import common from '@/assets/js/common'
export default {
  name: 'Payment',
  data () {
    return {
      orderid: '',
      // -------显示详情--------
      dialogVisible: false,
      // -------详情数据--------
      particularsData: {},
      // -------方法--------
      common,
      // -------------- [ 月结账单详情数据 ] --------------
      monthlyVisibleData: [],
      // -------------- [ 月结账单的账单号 ] --------------
      payid: '',
      // -------------- [ 月结账单id ] --------------
      soaid: '',
      // -------------- [ 钱包信息详情 ] --------------
      walletInfo: '',
      // -------------- [ 账单详情 ] --------------
      payparams: {},
      // -------------- [ 订单详情 ] --------------
      order_data: {},
      // -------------- [ 客服联系方式 ] --------------
      serviceInfo: {},
      // -------------- [ 是否显示联系客服 ] --------------
      isShowRelationService: false,
      // -------------- [ 加载动画 ] --------------
      loading: false,
      // -------------- [ 其他支付方式选择 ] --------------
      otherPayName: 'wechat',
      //--------------延时函数--------------
      refreshPlayFun: '',
      // -------------- [ 微信二维码 ] --------------
      wechatQr: '',
      // -------------- [ 是否显示微信二维码 ] --------------
      isWechatQr: false,
      // -------------- [ 默认展示项目 ] --------------
      activeName: '1',
      // -------------- [ 收款信息 ] --------------
      gathering: {
        skinfo: {
          skinfo: {
            bank: {}
          }
        }
      },
      // -------------- [ 组合表格数据 ] --------------
      tableData: [],
      // -------------- [ 支持的收款方式 ] --------------
      patternPayment: {},
      // -------------- [ 账单列表 ] --------------
      getBill_list: [{

      }]
    }
  },
  methods: {
    async getBill_order () {
      let res = await apiBill({
        orderid: this.orderid
      })
      if (res.errno == 0) {
        this.getBill_list = res.orderlist
      } else {
        this.getBill_list = []
      }
    },
    // -------显示详情--------
    showParticulars (row) {
      this.particularsData = row
      this.dialogVisible = true
    },
    // -------时结账单详情数据获取--------
    async getBill (soaid) {
      let res = await apiBillInfo({
        pd: 'getlist',
        soaid,
      })
      if (res.errno == 0) {
        this.monthlyVisibleData = res.orderlist
      } else {
        this.$message.error(res.message)
      }
    },

    // -------------- [ 钱包支付 ] --------------
    walletPay () {
      if (parseFloat(this.walletInfo) >= parseFloat(this.gathering.payparams.fee)) {
        this.sponsorWallet()
      } else {
        return this.$message.error('您的余额不够支付哦，请前往公众号充值后再支付。（ 电脑端充值正在完善中 ）')
      }
    },
    // -------------- [ 关闭弹框 ] --------------
    closeDialog () {
      clearInterval(this.refreshPlayFun);
    },
    // ------------关闭回调------------
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    // ------------显示财务联系方式------------
    getConfiguration () {
      this.isShowRelationService = true
    },

    // ------------显示微信付款------------
    confirmWechat () {
      this.getWeChatQR()
      this.refreshPayStatus()
      this.isWechatQr = true
    },
    // ------------获取用户是否付款成功------------
    async refreshPlay (type) {
      let res = await apiPlay({
        params: this.params,
        type,
        done: 1
      })
      return res.errno
    },
    // ------------获取微信支付二维码------------
    async getWeChatQR () {
      let res = await apiPlay({
        type: "wechat",
        params: this.params,
      })
      if (res.errno === 0) {
        this.wechatQr = res.wechatqrimg
      }
    },
    // ------------确认支付吗------------
    confirmPlay () {
      if (parseFloat(this.walletInfo.credit2, 10) < parseFloat(this.payparams.fee, 10)) {
        return this.$message({
          type: 'info',
          message: '您的余额不足，请先充值'
        });
      }
      this.$confirm(`您将使用余额支付，当前余额${this.walletInfo.credit2}`, '请确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sponsorWallet()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // ------------发起钱包支付------------
    async sponsorWallet () {
      let res = await apiPlay({
        params: this.params,
        type: "credit",
        done: 1
      })
      if (res.errno === 0) {
        this.$message.success(res.message)
        setTimeout(() => {
          this.$router.go(-1)
        }, 3000);
      }
    },
    // ------------获取钱包信息------------
    async getWallet () {
      this.fullscreenLoading = true

      let res = await apiUserData({
      })
      if (res.errno == 0) {
        this.walletInfo = res.allmoney
      }
      this.fullscreenLoading = false

    },
    // ------------获取支持的支付方式------------
    async getPlay () {
      this.fullscreenLoading = true
      let res = await apiGetPlay()
      if (res.errno === 0) {
        this.patternPayment = res.paylist
        this.getWallet()
      }
      this.fullscreenLoading = false
    },

    //获取订单详情
    async getOrderData () {
      this.fullscreenLoading = true
      let res = await apiOrderDetails({
        op: 'orderinfo',
        pd: 'getinfo',
        orderid: this.payparams.orderid
      })
      this.order_data = res
      this.bj = res.bj
      this.fullscreenLoading = false



    },
    //获取订单支付数据
    async getApiPayment () {
      this.fullscreenLoading = true
      let res = await apiPayment({
        payid: this.is_order == 1 ? this.payid : undefined,
        bjid: this.is_order == 2 ? this.bjid : undefined,
        orderid: this.is_order == 3 ? this.orderid : undefined,
      })
      this.gathering = res
      this.payparams = res.payparams
      this.params = res.params
      this.getOrderData()
      this.fullscreenLoading = false
    },

    //刷新支付状态
    refreshPayStatus () {
      let number = 0
      this.refreshPlayFun = setInterval(async () => {
        // ----------最多请求200次----------
        if (number > 200) {
          clearInterval(this.refreshPlayFun);
          this.$message.error('支付信息过期，请退出重进')
          setTimeout(() => {
            this.$router.go(-1)
          }, 2000);
        } else {
          number++
          if (await this.refreshPlay("wechat") === 1) {

          } else {
            clearInterval(this.refreshPlayFun);
            this.$message.success('付款成功，正在为您跳转')
            setTimeout(() => {
              this.$router.go(-1)
            }, 2000);
          }
        }
        // ----------如果为微信----------

      }, 2000);

    },



  },
  created () {
    this.getPlay()
    this.is_order = this.$route.query.order
    if (this.$route.query.order == 1) {
      this.soaid = this.$route.query.id
      this.payid = this.$route.query.payid
      this.getBill(this.soaid)
    } else if (this.$route.query.order == 2) {
      this.bjid = this.$route.query.id
    } else if (this.$route.query.order == 3) {
      this.orderid = this.$route.query.id
      this.getBill_order()
    }
    this.getApiPayment()

  },
  beforeDestroy () {
    clearInterval(this.refreshPlayFun);
  }
}
</script>

<style lang="scss">
.paymentPage {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  min-width: 1000px;
  position: relative;
  background-color: #fff;
  .bill_list {
    width: 100%;
    //   display: flex;
    flex-wrap: wrap;
    .bill_item {
      width: 100%;
      display: flex;
      margin-bottom: 15px;
      // flex-direction: column;
      .bill_title {
        width: 90px;
        color: #999;
      }
    }
  }
  .service_view {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .scanQr_view {
    .el-dialog {
      border-radius: 10px;
      .el-dialog__body {
        display: flex;
        justify-content: center;
      }
    }
  }
  .absolute_bottom {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
    height: 70px;
    position: absolute;
    background-color: #fff;
    border-top: 1px solid #eee;
    z-index: 999;
    left: 0;
    bottom: 0;
    .bottom_btn {
      margin-right: 30px;
    }
    .bottom_price {
      display: flex;
      align-items: flex-end;
      margin-right: 20px;
      .price_title {
        font-size: 12px;
        color: #333;
      }
      .price {
        font-size: 18px;
        color: #f56c6c;
        font-weight: 700;
      }
    }
  }
  .el-tag {
    width: 100%;
    height: 50px;
    margin: 40px 0;
  }
  .otherPay {
    width: 100%;
    .otherPay_view {
      display: flex;
      width: 100%;
    }
    .noonlinepay {
      flex: 1;
      max-width: 100px !important;
      min-width: 100px !important;
      .el-tabs__content {
        display: none;
      }
    }
    .tabs_view {
      flex: 1;
      // background: pink;
      .bank_item:hover {
        background-color: #409eff !important;
        color: #fff !important;
      }
      .bank_view_item {
        justify-content: start !important;
        align-items: flex-start !important;
        box-sizing: border-box;
        padding: 50px 0;
        .bank_item {
          cursor: pointer;
          width: 400px;
          height: 90px;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 5px 10px;
          background-color: #f5f5f5;
          color: #666;
          .item_content {
            font-size: 14px;
            display: flex;
            .content_title {
              width: 100px;
            }
          }
        }
      }
      .tabs_view_item {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .item_text {
          color: #67c23a;
          margin-bottom: 20px;
          font-weight: 700;
          letter-spacing: 2px;
        }
      }
    }
  }

  .wallet {
    width: 100%;
    height: 100px;
    // background-color: pink;
    display: flex;
    align-items: center;
  }

  .orderInfo {
    width: 100%;
    // height: 200px;
    // background-color: rgba(153, 153, 153, 0.199);
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
    .el-table {
      margin-top: 20px;
    }
    .orderInfo_centent {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .orderInfo_centent,
    .centent_item {
      display: flex;
      align-items: center;
    }
    .centent_item {
      margin-right: 40px;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      line-height: 23px;
      color: #909399;
      text-indent: initial;
      border-spacing: 2px;
      font-size: 14px;
      font-weight: 700;
    }
  }
  .noonlinepay {
    margin-top: 50px;
    .el-tabs__item {
      font-size: 14px !important;
      font-weight: normal;
    }
  }
  .el-tabs {
    min-width: 1000px;
    .el-tabs__item {
      font-size: 18px;
      color: #999;
      cursor: pointer;
    }
    .el-tabs__item.is-active {
      color: #409eff;
      font-weight: 700;
    }
    // height: ;
  }
}
</style>